var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 4.41357H5.75C5.35218 4.41357 4.97064 4.57161 4.68934 4.85291C4.40804 5.13422 4.25 5.51575 4.25 5.91357V14.9136C4.25 15.3114 4.40804 15.6929 4.68934 15.9742C4.97064 16.2555 5.35218 16.4136 5.75 16.4136H13.25C13.6478 16.4136 14.0294 16.2555 14.3107 15.9742C14.592 15.6929 14.75 15.3114 14.75 14.9136V5.91357C14.75 5.51575 14.592 5.13422 14.3107 4.85291C14.0294 4.57161 13.6478 4.41357 13.25 4.41357H11.75",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 4.41357C7.25 4.01575 7.40804 3.63422 7.68934 3.35291C7.97064 3.07161 8.35218 2.91357 8.75 2.91357H10.25C10.6478 2.91357 11.0294 3.07161 11.3107 3.35291C11.592 3.63422 11.75 4.01575 11.75 4.41357C11.75 4.8114 11.592 5.19293 11.3107 5.47423C11.0294 5.75554 10.6478 5.91357 10.25 5.91357H8.75C8.35218 5.91357 7.97064 5.75554 7.68934 5.47423C7.40804 5.19293 7.25 4.8114 7.25 4.41357Z",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 13.4136V10.4136",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.4136V12.6636",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13.4136V11.9136",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.4136V12.6636",
    stroke: "#ACACAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.663574)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo4);
export default __webpack_public_path__ + "static/media/info4.22e082806d1ef92d858c4a7bc57cca36.svg";
export { ForwardRef as ReactComponent };